import { render, staticRenderFns } from "./DistrictPopTables.vue?vue&type=template&id=2fb90875"
import script from "./DistrictPopTables.vue?vue&type=script&lang=js"
export * from "./DistrictPopTables.vue?vue&type=script&lang=js"
import style0 from "./DistrictPopTables.vue?vue&type=style&index=0&id=2fb90875&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports